// *******************************************************
// API request to Salesforce
// *******************************************************
// Send request data to salesforce for price
import axios from "axios";
const sendHttpRequestQuote = async (apiName, json) => {
  campaignStorageTracking(true);
  try {
    let response = await axios.post(process.env.VUE_APP_RESTURL + "services/apexrest/" + apiName, json);
    return response;
  } catch (error) {
    return error;
  }
};

// Normalize query string: fully decode it once so encoded delimiters (%26, %3D) become real & and =
// This handles cases where the entire query string was double-encoded or encoded as a single parameter
const normalizeQueryString = (search) => {
  try {
    const decoded = decodeURIComponent(search);
    // Only use decoded version if it actually changed the string (had encoded delimiters)
    return decoded !== search ? decoded : search;
  } catch (e) {
    return search;
  }
};

const campaignStorageTracking = (skipGetUTMFromURL) => {
    const urlPathname = window.parent.location.pathname;
    const urlParams = new URLSearchParams(normalizeQueryString(window.parent.location.search));
    let campaignStorage = {};
    let utmSource = "", utmCampaign = "", utmMedium = "", utmTerm = "", gclid = "", fclid = "", referrer = "", etid = "", promoCode = "";
    const campaignURL = JSON.parse(sessionStorage.getItem("campaignURL"));

    if (campaignURL) {
      utmSource = campaignURL["utmSource"];
      utmCampaign = campaignURL["utmCampaign"];
      utmMedium = campaignURL["utmMedium"];
      utmTerm = campaignURL["utmTerm"];
      gclid = campaignURL["gclid"];
      fclid = campaignURL["fclid"];
      referrer = campaignURL["referrer"];
      etid = campaignURL["etid"];
      promoCode = campaignURL["promoCode"];
    }

    if(!skipGetUTMFromURL){
    campaignStorage["utmSource"] = urlParams.get("utm_source")?encodeURIComponent(urlParams.get("utm_source")):utmSource?utmSource:"";
    campaignStorage["utmCampaign"] = urlParams.get("utm_campaign")?encodeURIComponent(urlParams.get("utm_campaign")):utmCampaign?utmCampaign:"";
    campaignStorage["utmMedium"] = urlParams.get("utm_medium")?encodeURIComponent(urlParams.get("utm_medium")):utmMedium?utmMedium:"";
    campaignStorage["utmTerm"] = urlParams.get("utm_term")?encodeURIComponent(urlParams.get("utm_term")):utmTerm?utmTerm:"";
    campaignStorage["gclid"] = urlParams.get("gclid")?encodeURIComponent(urlParams.get("gclid")):gclid?gclid:"";
    campaignStorage["fclid"] = urlParams.get("fclid")?encodeURIComponent(urlParams.get("fclid")):fclid?fclid:"";
    campaignStorage["referrer"] = urlParams.get("referrer") ? (urlParams.get("referrer").startsWith("http://") || urlParams.get("referrer").startsWith("https://")) ? urlParams.get("referrer") : encodeURIComponent(urlParams.get("referrer")) : document.referrer ? new URL(document.referrer).origin + new URL(document.referrer).pathname : referrer ? referrer : "";
    campaignStorage["etid"] = urlParams.get("etid")?encodeURIComponent(urlParams.get("etid")):etid?etid:"";
    campaignStorage["promoCode"] = urlPathname==="/rolloff-springclean-lp/"?true:promoCode?promoCode:false;

    if (campaignStorage["utmSource"]||campaignStorage["utmCampaign"]||campaignStorage["utmMedium"]||campaignStorage["utmTerm"]||campaignStorage["gclid"]||campaignStorage["fclid"]||campaignStorage["referrer"]||campaignStorage["etid"]||campaignStorage["promoCode"]){
      sessionStorage.setItem("campaignURL", JSON.stringify(campaignStorage));
    }
}
};
export default {sendHttpRequestQuote,campaignStorageTracking};